import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import styles from './Modal.module.scss'
import SavingModal from './save'
import { SAVING, modalStyle } from '../../../utils/constants'

/**
* @author
* @function Modal
* */

const ModalWindow = props => {
	const { isVisible, purpuse, requestClose, modalData } = props

	function decidePurpose(p) {
		switch (p) {
		case SAVING:
			return <SavingModal modalData={modalData} requestClose={requestClose} />
		default:
			return null
		}
	}

	return (
		<Modal
			isOpen={isVisible}
			style={modalStyle}
			contentLabel="Example Modal"
			onRequestClose={requestClose}
		>
			<div className={styles.modalContainer}>
				{
					decidePurpose(purpuse)
				}
			</div>
		</Modal>
	)
}

ModalWindow.defaultProps = {
	modalData: null,
}

ModalWindow.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	modalData: PropTypes.objectOf({}),
	purpuse: PropTypes.string.isRequired,
	requestClose: PropTypes.func.isRequired,
}

export default ModalWindow
